"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.earnLimitPeriodUnitOptions = exports.earnModeOptions = exports.earnSourceOptions = exports.orderStatusOptions = exports.orderChannelOptions = exports.paymentTypeOptions = exports.orderMethodOptions = exports.titleMap = exports.EarnConfigType = exports.excludeCategoriesTableColumns = exports.excludeProductsTableColumns = exports.excludeTypeOptions = exports.currencyTypeOptions = exports.tableColumns = void 0;
exports.tableColumns = [
    {
        displayKey: "name",
        label: "Name",
    },
    {
        displayKey: "created_at",
        label: "Created",
    },
    {
        displayKey: "updated_at",
        label: "Last Saved",
    },
];
exports.currencyTypeOptions = [
    {
        label: "Real Exchangeable Currency",
        description: "A real-world currency such as ZAR or USD.",
        value: "real",
    },
    {
        label: "Virtual Currency",
        description: "Your own currency, such as points or gems, with a conversion rate you set.",
        value: "virtual",
    },
];
exports.excludeTypeOptions = [
    {
        label: "Products",
        value: "product",
    },
    {
        label: "Product Categories",
        value: "category",
    },
];
exports.excludeProductsTableColumns = [
    {
        displayKey: "image_url",
        label: "Image",
    },
    {
        displayKey: "title",
        label: "Title",
    },
    {
        displayKey: "sku",
        label: "SKU",
    },
    {
        displayKey: "pid",
        label: "PID",
    },
    {
        displayKey: "action",
        label: "Action",
    },
];
exports.excludeCategoriesTableColumns = [
    {
        displayKey: "image_url",
        label: "Image",
    },
    {
        displayKey: "name",
        label: "Name",
    },
    {
        displayKey: "description",
        label: "Description",
    },
    {
        displayKey: "action",
        label: "Action",
    },
];
var EarnConfigType;
(function (EarnConfigType) {
    EarnConfigType["Currency"] = "currency";
    EarnConfigType["Statistic"] = "statistic";
})(EarnConfigType || (exports.EarnConfigType = EarnConfigType = {}));
exports.titleMap = (_a = {},
    _a[EarnConfigType.Currency] = "Cashback",
    _a[EarnConfigType.Statistic] = "XP Reward",
    _a);
// Order method filter options
exports.orderMethodOptions = [
    { label: "Collection (Pick Up)", value: "COLLECTION" },
    { label: "Delivery", value: "DELIVERY" },
    { label: "Free Delivery", value: "FREE-DELIVERY" },
];
// Payment type filter options
exports.paymentTypeOptions = [
    { label: "Wallet", value: "WALLET" },
    { label: "Card", value: "CARD" },
    { label: "POS (External Payment)", value: "POS" },
    { label: "Kiosk (External Payment)", value: "KIOSK" },
    { label: "Voucher", value: "VOUCHER" },
    { label: "Subscription", value: "SUBSCRIPTION" },
    { label: "Loan", value: "LOAN" },
];
// Order channel filter options
exports.orderChannelOptions = [
    { label: "App/Web", value: "LETS-TRADE" },
    { label: "In-Store POS", value: "POS" },
    { label: "Kiosk", value: "KIOSK" },
    { label: "Google", value: "GOOGLE" },
    { label: "Shopify", value: "SHOPIFY" },
    { label: "Facebook", value: "FACEBOOK" },
    { label: "Arch Store", value: "ARCH_STORE" },
];
// Order status filter options (for required_statuses)
exports.orderStatusOptions = [
    { label: "Ordered (Finalized)", value: "ORDERED" },
    { label: "POS Ordered", value: "POS-ORDERED" },
    { label: "Fulfilled", value: "FULFILLED" },
    { label: "Collected", value: "COLLECTED" },
    { label: "Delivered", value: "DELIVERED" },
    { label: "Processing", value: "PROCESSING" },
];
// Earn source options
exports.earnSourceOptions = [
    { label: "Orders", value: "orders" },
    { label: "Gift Cards", value: "gifts" },
    { label: "Subscriptions", value: "subscriptions" },
];
// Earn calculation mode options
exports.earnModeOptions = [
    { label: "Threshold-based", value: "threshold" },
    { label: "Percentage-based", value: "percentage" },
];
// Frequency cap period options
exports.earnLimitPeriodUnitOptions = [
    { label: "Hour(s)", value: "hour" },
    { label: "Day(s)", value: "day" },
    { label: "Week(s)", value: "week" },
    { label: "Month(s)", value: "month" },
];
